﻿import { api } from '@cwd/lib/main';
import { CreditCardReference } from '@cwd/Account/CreditCards/CreditCards.access';

export interface UpgradeLimitReference {
    ContactsLimit: number | null;
    EmailLimit: number | null;
    Tier: string | null;
    Feature: string | null;
}

export interface UpgradeReference {
    CanUpgrade: string;
    ReasonForNotUpgrading: string;
    NextServiceLevelPrice: ServiceLevelPrice;
}

export interface ServiceLevelPrice {
    Currency: Currency;
    MonthlyPrice: number;
    NextPaymentAmount: number;
    NextPaymentDate: Date;
    CreditAmount: number;
    OverDraftAmount: number;
    UpgradeAmount: number;
    DaysToPayOldLevel: number;
    DaysToPayNewLevel: number;
    DaysToGiveCreditFor: number;
    PaidUntil: Date | null;
    ServiceLevel: ServiceLevel;
    ServiceLevelPriceId: number;
    ServiceSubscriptionTier: ServiceSubscriptionTier;
    TotalDue: number;
    TotalExclVat: number;
    VatAmount: number;
    VatPercentage: number;
}

export interface Currency {
    CurrencyCode: string;
    Name: string;
    RateToEur: number;
}

export interface ServiceLevel {
    ServiceLevelId: string;
    Name: string;
    ContactLimit: number;
    EmailLimit: number;
}

export interface ServiceSubscriptionTier {
    ServiceSubscriptionTierId: string;
    Name: string;
    IsFree: boolean;
    Version: number;
    RequiresBanner: boolean;
}

export interface AccountUpgradeReference {
    ServiceLevelPrice: ServiceLevelPrice;
    CreditCard: CreditCardReference;
    PayByInvoice: boolean;
    SuccessfulPaymentUrl: string;
    CancelledPaymentUrl: string;
    InitiatedUrl: string;
    LimitInfo: UpgradeLimitReference | null;
}

export async function getNextServiceLevelPrice(upgradeLimitReference: UpgradeLimitReference): Promise<UpgradeReference> {
    return api.post('/Accounts/Current/NextServiceLevelPrice', upgradeLimitReference);
}

export async function upgradeAccount(accountUpgradeReference: AccountUpgradeReference): Promise<string> {
    return api.post('/Accounts/Upgrade', accountUpgradeReference);
}
